import { matchAll } from '@nrdy-marketing-engine/match-helpers/src';
import { ActionData } from '../@types/action';
import { FormMetaData } from '../@types/form-props';
import { StepData } from '../@types/step-data';
import getNextItem from './get-next-item';

export interface ActionProps {
  formData: Record<string, any>;
  formMetaData?: FormMetaData;
  step: ActionData;
  steps: StepData[];
}

interface Action extends ActionProps {}

/**
 * Base class that represents an action step. Actions, unlike panels, have no visual UI.
 * They perform an asynchronous action (like submitting a form, updating data), and then
 * continue to the next step, until reaching a panel.
 *
 * All actions should extend this base class and implement the `perform` method.
 */
class Action {
  constructor({ step, steps, formData, formMetaData }: ActionProps) {
    this.step = step;
    this.formData = formData;
    this.formMetaData = formMetaData;
    this.steps = steps;
  }

  async perform(): Promise<StepData | null> {
    throw `${this.constructor.name} is missing implementation`;
  }

  /** Returns true if all form field conditions defined for this action have been met. */
  conditionsSatisfied() {
    return matchAll(this.conditions, this.formData);
  }

  get stepName() {
    return this.step.stepName;
  }

  get _modelApiKey() {
    return this.step._modelApiKey;
  }

  get conditions() {
    return this.step.conditions;
  }

  getNextStep() {
    return getNextItem(this.steps, this.step);
  }
}

export default Action;
